import { Alert, AlertIcon } from '@chakra-ui/react'
import React from 'react'

export default function ErrorComponent({message}) {
  return (
    <>
        <Alert status='error' position={'fixed'} bottom={'4'} width={'container.lg'} left={'50%'} transform={'translateX(-50%)'}>
            <AlertIcon/>
            {message}
        </Alert>
    </>
  )
}
